module.exports = __webpack_public_path__ + "static/img/01526v.f4cb4c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/01526v.jpg
// module id = 0T4O
// module chunks = 1